// extracted by mini-css-extract-plugin
export var typingIndicator = "_oa-0";